<ng-container *ngTemplateOutlet="template"></ng-container>
